import Button from 'antd/lib/button';
import { message, Modal, Row, Tree } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStateDepartment, IStoreState } from 'src/entity/StateEntity';
import DepartmentAdminService from 'src/services/DepartmentAdminService';
import I18N from 'src/services/I18NService';
import { AntTreeNodeSelectedEvent } from 'antd/lib/tree';
import DepartmentForm from './DepartmentForm';
import { TreeNodeNormal } from 'antd/lib/tree/Tree';

interface IProps {
  departmentState: IStateDepartment,
  disableSelect: boolean,
  defaultDepartmentId: string | undefined,
  onDepartmentChange: (selectedDepartmentId: string, isTop: boolean) => void,
  dispatch: Dispatch<IStateDepartment>,
}

const mapStateToProps = ({
  departmentState,
}: IStoreState) => ({
  departmentState,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateDepartment>) => {
  return {
    dispatch,
  };
};

const DepartmentTreeComp: React.FC<IProps> = (props) => {
  const {
    defaultDepartmentId,
    departmentState,
    disableSelect,
    dispatch,
    onDepartmentChange,
  } = props;
  const { list } = departmentState;

  const [selectedDepartmentId, setSelectedDepartmentId] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [formStatus, setFormStatus] = useState('add' as 'add' | 'edit');

  const treeData = useMemo(() => {
    const result = DepartmentAdminService.buildDepartmentTreeData(list);
    return result;
  }, [list]);

  const topDepartmentId = treeData[0] ? treeData[0].value as string : '';

  useEffect(() => {
    let result = ''; 
    result = defaultDepartmentId ? defaultDepartmentId : topDepartmentId;
    setSelectedDepartmentId(result);
  }, [defaultDepartmentId, treeData]);

  const handleModalOpen = (type: 'add' | 'edit') => {
    if (selectedDepartmentId === topDepartmentId && type === 'edit') {
      // 顶层部门不允许编辑
      message.error('顶层部门不允许编辑!');
      return;
    }
    let title = '';
    if (type === 'add') {
      title = 'common_new';
    } else if (type === 'edit') {
      title = 'common_edit';
    }
    title = `${I18N.get(title)}${I18N.get('departmentAdmin_department')}`;
    setModalVisible(true);
    setModalTitle(title);
    setFormStatus(type);
  };

  const handleTreeNodeSelect = (selectedKeys: string[], event: AntTreeNodeSelectedEvent) => {
    const {node} = event;
    const {value} = node.props;
    if (!disableSelect) {
      setTimeout(() => {
        setSelectedDepartmentId(value);
        const isTop = value === topDepartmentId;
        onDepartmentChange(value, isTop);
      }, 0);
    }
  }

  const handleModalClose = useCallback(() => {
    setModalVisible(false);
  },[]);

  const handleDelleted = useCallback(() => {
    setSelectedDepartmentId(topDepartmentId);
    onDepartmentChange(topDepartmentId, true);
  }, []);


  return (
    <section style={{ border: '1px solid #e5e5e5', height: '100%', display: 'flex', flexFlow: 'column nowrap'}}>
      <Row type="flex" justify="center" style={{padding: '12px 0', borderBottom: '1px solid #e5e5e5'}}>
        <Button
          type="primary"
          onClick={() => {handleModalOpen('edit')}}
        >
          {I18N.get('common_edit')}
        </Button>
        <Button
          type="primary"
          style={{marginLeft: 16}}
          onClick={() => {handleModalOpen('add')}}
        >
          {I18N.get('common_new')}
        </Button>
      </Row>
      <div style={{padding: 16, height: '100%', overflow: 'auto'}}>
        {treeData.length > 0 && (
          <Tree
            showIcon={false}
            treeData={treeData as TreeNodeNormal[]}
            defaultExpandAll={true}
            selectedKeys={[selectedDepartmentId]}
            selectable={!disableSelect}
            onSelect={handleTreeNodeSelect}
          />
        )}
      </div>
      <Modal
          title={modalTitle}
          visible={modalVisible}
          maskClosable={false}
          width={600}
          bodyStyle={{padding: "30px 100px"}}
          destroyOnClose={true}
          footer={null}
          onCancel={handleModalClose}
        >
          {modalVisible && (
            <DepartmentForm
              allDepartments={list}
              formStatus={formStatus}
              departmentId={selectedDepartmentId}
              departmentTree={treeData}
              onDispatch={dispatch}
              onDeleted={handleDelleted}
              onFinished={handleModalClose}
            />
          )}
        </Modal>
    </section>
  )
};

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentTreeComp);


// WEBPACK FOOTER //
// ./src/components/views/DepartmentAdmin/Department/DepartmentTree.tsx